import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
const DefaultLayout = [
    {
        "groupId": 1,
        "label": "Plan/Appointment",
        "fields": [
            {
                "name": "DELIVERYPICKUPPLANNEDDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "From",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DELIVERYPICKUPARRIVEDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "To",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "R_PLANWAREHOUSE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "WH",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "R_PLANLOCATION",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Dock",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "PLANRESOURCESCODE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Resources Code",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PLANRESOURCESHOURS",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Resources Hours",
                "type": "time",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PLANREFERENCE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Reference No",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PLANCOMMENT",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Staging",
        "fields": [
            {
                "name": "R_STAGINGWAREHOUSE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "WH",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_STAGINGAREA",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Area",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PLANNEDRECEIVEDSHIPPEDDATETIME",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Planned",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "STAGINGSTARTDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Start",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STAGINGENDDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Finish",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Assignments",
        "fields": [
            {
                "name": "R_UNLOADPICKBY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Unload By Worker",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNLOADPICKBYPLANDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Unload By Plan Date Time",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNLOADHOURS",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Unload By Hours",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNLOADMINUTES",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Unload By Minutes",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_PUTAWAYBY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Put Away By",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PUTAWAYBYPLANDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Put Away By Plan Date Time",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PUTAWAYHOURS",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Put Away By Hours",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PUTAWAYMINUTES",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Put Away By Minutes",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_CHECKBY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Check By",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CHECKBYPLANDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Check By Plan Date Time",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CHECKHOURS",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Check By Hours",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CHECKMINUTES",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Check By Minutes",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_LOADBY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Load By",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LOADBYPLANDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Load By Plan Date Time",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LOADHOURS",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Load By Hours",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LOADMINUTES",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Load By Minutes",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_PICKBY",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Pick By",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PICKBYPLANDATE",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Pick By Plan Date Time",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PICKHOURS",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Pick By Hours",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PICKMINUTES",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Pick By Minutes",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
let ignoreValueChange = false;


function SchedulingTab(props) {
    
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});

    const loadLookupFromDataSource = (name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
        }
        else {
            console.log('not found control:');
        }
    };

    const loadCodesLookupFromDataSource = (name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'name');
            formRefs.current[name].instance().option('displayExpr', 'name');
        }
        else {
            console.log('not found control:');
        }
    };

    const handleFieldChange = useCallback((name, value, e) => {
        
        if(name == 'R_STAGINGWAREHOUSE' && ignoreValueChange == false)
        {
            if(formRefs.current['R_STAGINGAREA'])
            {
                formRefs.current['R_STAGINGAREA'].instance().option('value', null);
            }
            
            var areaDataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                    loadParams:
                    {
                        locationTypes: 'L',
                        warehouseRowId: value
                    },
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
    
            loadLookupFromDataSource("R_STAGINGAREA", areaDataSource);
        }


        if(name == 'R_PLANWAREHOUSE' && ignoreValueChange == false)
        {
            if(formRefs.current['R_PLANLOCATION'])
            {
                formRefs.current['R_PLANLOCATION'].instance().option('value', null);
            }
            
            var areaDataSource = new DataSource({
                store: new createStore({
                    key: 'id',
                    loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                    loadParams:
                    {
                        locationTypes: 'L',
                        warehouseRowId: value
                    },
                    onBeforeSend: function (method, ajaxOptions) {
                        ajaxOptions.headers = {
                            Authorization: `Bearer ${accessToken}`
                        };
                    }
                }),
                paginate: true,
                pageSize: 100
            });
    
            loadLookupFromDataSource("R_PLANLOCATION", areaDataSource);
        }
        

    }, []);


    const handleSelectionChange = useCallback((name, e) => {
        
        if(name == 'R_STAGINGAREA' && e.selectedItem != null)
        {
            if(formRefs.current['R_STAGINGWAREHOUSE'])
            {
                var stagingWarhouseRowId = formRefs.current['R_STAGINGWAREHOUSE'].instance().option('value');
                if(stagingWarhouseRowId == null || stagingWarhouseRowId == undefined)
                {
                    ignoreValueChange = true;
                    formRefs.current['R_STAGINGWAREHOUSE'].instance().option('value', e.selectedItem.warehouseRowId);
                    ignoreValueChange = false;
                    
                }
            }
        }

        if(name == 'R_PLANLOCATION' && e.selectedItem != null)
        {
            if(formRefs.current['R_PLANWAREHOUSE'])
            {
                var stagingWarhouseRowId = formRefs.current['R_PLANWAREHOUSE'].instance().option('value');
                if(stagingWarhouseRowId == null || stagingWarhouseRowId == undefined)
                {
                    ignoreValueChange = true;
                    formRefs.current['R_PLANWAREHOUSE'].instance().option('value', e.selectedItem.warehouseRowId);
                    ignoreValueChange = false;
                    
                }
            }
        }

    }, []);


    const handleDefaultFormLoad = useCallback(() => {
        var warehouseDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetWarehouses`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });

        loadLookupFromDataSource("R_STAGINGWAREHOUSE", warehouseDataSource);
        loadLookupFromDataSource("R_PLANWAREHOUSE", warehouseDataSource);

        var areaDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                loadParams:
                {
                    locationTypes: 'L'
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });

        loadLookupFromDataSource("R_STAGINGAREA", areaDataSource);

        var planDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                loadParams:
                {
                    locationTypes: 'D'
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });

        loadLookupFromDataSource("R_PLANLOCATION", planDataSource);

        const codesDataSource = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                key: 'name',
                loadParams: {
                    codeType: "46"
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });

        loadCodesLookupFromDataSource("PLANRESOURCESCODE", codesDataSource);

        var workerDataSource = new DataSource({
            store: new createStore({
                key: 'id',
                loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetWorkers`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });

        loadLookupFromDataSource("R_UNLOADPICKBY", workerDataSource);
        loadLookupFromDataSource("R_PUTAWAYBY", workerDataSource);
        loadLookupFromDataSource("R_CHECKBY", workerDataSource);
        loadLookupFromDataSource("R_LOADBY", workerDataSource);
        loadLookupFromDataSource("R_PICKBY", workerDataSource);

        formRefs.current["UNLOADHOURS"].instance().option('disabled', true);
        formRefs.current["UNLOADMINUTES"].instance().option('disabled', true);
        formRefs.current["PUTAWAYHOURS"].instance().option('disabled', true);
        formRefs.current["PUTAWAYMINUTES"].instance().option('disabled', true);
        formRefs.current["CHECKHOURS"].instance().option('disabled', true);
        formRefs.current["CHECKMINUTES"].instance().option('disabled', true);
        formRefs.current["LOADHOURS"].instance().option('disabled', true);
        formRefs.current["LOADMINUTES"].instance().option('disabled', true);
        formRefs.current["PICKHOURS"].instance().option('disabled', true);
        formRefs.current["PICKMINUTES"].instance().option('disabled', true);

        if(props.isCommittedTransaction){
            if (formRefs.current) {
                Object.keys(formRefs.current).forEach((key) => {
                    //if (key === "REFERENCE" || key === "COMMENT") return;
                    const instance = formRefs.current[key]?.instance;
                    if (instance && typeof instance.option === 'function') {
                        instance.option('disabled', true);
                    }
                });
            }
        }

    }, []);

    useEffect(() => {
    }, []);


    return (
        <FormField
            currrentUser={currentUser}
            layoutId='2253fc36-6977-43cf-a7d1-1e82b4695e5f'
            defaultFormSchema={DefaultLayout}
            formFields={props.formFields}
            setformFields={props.setformFields}
            handleFieldValueChange={handleFieldChange}
            handleSelectedItemChange={handleSelectionChange}
            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
            formRefs={formRefs}
            onFormLoad={handleDefaultFormLoad}
        />
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(SchedulingTab);
